import {
  dynamicRemarketing,
  virtualPageView
} from "../../shared/helpers/gtm_tracking";

import {
  addInvalidSubmitHandler,
  setTitle,
  setSubtitle,
  setButtonText,
  setCallUsText,
  setAdditionalInfoPlaceholder,
  setCountryDropdownVisibility,
  handleSubmit,
  resetModal,
  formFieldFocusHandler,
  initLoadCountryPhone
} from "../../utils/Enquiries";
import initForm from "../../utils/Forms";

const handleClick = (enquiry, buttonSelector) => e => {
  const button = e.target.closest(buttonSelector);

  if (button) {
    e.preventDefault();
    const slug = window.location.pathname.split("/")[1];
    const {
      enquiryTitle,
      enquiryPrice,
      enquiryNights,
      enquiryDate,
      enquirySubtitle,
      enquiryButton,
      enquiryAdditionalInfo,
      enquiryCallUs,
      enquiryShowCountryDropdown,
    } = button.dataset;

    setTitle(enquiry, enquiryTitle);
    setSubtitle(enquiry, { nights: enquiryNights, date: enquiryDate, override: enquirySubtitle });
    setButtonText(enquiry, enquiryButton);
    setAdditionalInfoPlaceholder(enquiry, enquiryAdditionalInfo);
    setCallUsText(enquiry, enquiryCallUs);
    setCountryDropdownVisibility(enquiry, enquiryShowCountryDropdown);

    enquiry.querySelector(".js-enquiry-subject").value = enquiryTitle;
    enquiry.querySelector(".js-enquiry-price").style.display = enquiryPrice ? "block" : "none";

    $("#js-named-enquiry-modal").modal("show");

    if (enquiryPrice) {
      enquiry.querySelector(".js-enquiry-price .price").textContent = `£${enquiryPrice}`;

      dynamicRemarketing({
        hrental_id: slug,
        hrental_totalvalue: parseInt(enquiryPrice, 10),
        hrental_pagetype: "conversionintent"
      });
    }

    virtualPageView("PERSONAL_DETAILS");
  }
};

const initNamedEnquiry = () => {
  const enquiry = document.querySelector("#js-named-enquiry");
  const form = enquiry.querySelector(".js-enquiry-form");

  resetModal(enquiry);

  initForm(form, { submit: handleSubmit(enquiry) });

  document.body
    .addEventListener("click", handleClick(enquiry, ".js-named-enquiry-button"));

  formFieldFocusHandler(enquiry);

  addInvalidSubmitHandler(form);

  initLoadCountryPhone(enquiry);
}

export default initNamedEnquiry;



// WEBPACK FOOTER //
// ./components/enquiries/named_enquiry.js